import React, { PropsWithChildren } from "react";
import cs from "classnames";
import { Icon } from "../../../shared/Icon/Icon";

export const AddReservation = ({
  handleClick,
  disabled,
  tooltip,
}: PropsWithChildren<{
  handleClick: () => void;
  disabled?: boolean;
  tooltip?: string;
}>) => {
  return (
    <div
      className={cs("AddReservation mt-4 mb-2", {
        "AddReservation--disabled": disabled,
      })}
    >
      <div className="divider mr-4"></div>

      <Icon
        onClick={disabled ? undefined : handleClick}
        icon="add-green-icon"
      />

      {disabled && tooltip && (
        <span className="AddReservation__tooltip">{tooltip}</span>
      )}

      <div className="divider ml-4"></div>
    </div>
  );
};
